<template>
    <div>
        <v-form ref="formulario">
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-card flat>
                            <v-toolbar dense class="elevation-0">
                                <v-icon v-if="currentFormula.fiable" color="success">mdi-shield-check</v-icon>
                                <v-icon v-else-if="!currentFormula.fiable" color="error">mdi-shield-off</v-icon>
                                <span>&nbsp;</span>
                                <v-toolbar-title>{{ this.editing ? this.$route.params.id : 'Nueva' }}</v-toolbar-title>
                                <v-spacer></v-spacer>

                                <div v-if="currentFormula.id_busqueda == null">
                                    <v-btn v-if="this.editing" color="primary" class="mr-2" @click="showClonarDialog">
                                        Clonar
                                    </v-btn>

                                    <v-dialog v-model="dialogClonar" persistent max-width="600">
                                        <v-card>
                                            <v-card-title class="text-h5">
                                                Clonar la fórmula {{ this.$route.params.id }}
                                            </v-card-title>
                                            <v-card-text>
                                                Introduzca el nuevo código:

                                                <v-text-field v-model="cod_formula_clonado">
                                                </v-text-field>

                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="secondary" text @click="dialogClonar = false">
                                                    Cancelar
                                                </v-btn>
                                                <v-btn color="primary" text @click="clonarFormula()">
                                                    Clonar
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </div>

                                <v-alert v-if="currentFormula.id_busqueda != null" type="warning" icon="mdi-brain">
                                    <v-row align="center">
                                        <v-col class="grow">
                                            Estás visualizando una sugerencia
                                        </v-col>
                                        <v-col class="shrink">
                                            <v-dialog v-model="dialogConvertirFormula" persistent max-width="600px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn dark v-bind="attrs" v-on="on">
                                                        Convertir en Formula
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="text-h5">Convertir en Formula</span>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        Al convertir esta sugerencia como <b>fórmula segura</b> será
                                                        añadida a la base
                                                        de datos del conocimiento. Revisen los datos introducidos.
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeConvertirFormula">
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn color="blue darken-1" text @click="convertirFormula">
                                                            CONVERTIR
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-col>
                                    </v-row>
                                </v-alert>
                            </v-toolbar>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col md="3">
                        <v-text-field v-model="currentFormula.cod_formula"
                            :rules="[(v) => !!v || 'Código de formula es necesario']" label="Codigo" required>
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="currentFormula.descripcion" label="Descripción">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col>
                        <v-text-field v-model="currentFormula.cliente" label="Cliente">
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field v-model="currentFormula.especificacion" label="Especificación">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field label="Temperatura Servicio" prepend-icon="mdi-thermometer" type="number" clearable
                            suffix="ºC" v-model="currentFormula.temp_servicio"
                            :rules="[(v) => !!v || 'Este campo es obligatorio']">
                        </v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field label="Densidad" prepend-icon="mdi-dots-hexagon" type="number" clearable
                            v-model="currentFormula.densidad" :rules="[(v) => !!v || 'Este campo es obligatorio']">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-autocomplete v-model="currentFormula.id_color" :items="colores" :item-text="getColorName"
                            item-value="id_color" label="Color" prepend-icon="mdi-palette" return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.id_color" close @click="data.select"
                                    @click:close="removeColor(data.item)">
                                    {{ getColorName(data.item) }}
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-autocomplete v-model="currentFormula.proceso" :items="proceso" item-text="name"
                            item-value="value" label="Proceso" :filter="customFilter"
                            :rules="[(v) => !!v || 'Escoja un proceso']">
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete v-model="model_aplicacion" :items="aplicaciones" label="Aplicación"
                            prepend-icon="mdi-application" item-text="nombre" item-value="id_aplicacion" multiple
                            return-object chips>

                            <template v-slot:selection="data">
                                <v-chip v-bind="data.attrs" :input-value="data.item.id_aplicacion" close
                                    @click="data.select" @click:close="removeAplicacion(data.item)">
                                    {{ data.item.nombre }}
                                </v-chip>
                            </template>

                        </v-autocomplete>
                    </v-col><v-col cols="12" sm="6">
                        <v-text-field label="Precio" prepend-icon="mdi-cash-multiple" v-model="precio_total" disabled
                            suffix="€/Kg" />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-card flat>
                            <vc-donut :size="40" unit="%" :thickness="30" :sections="formula_bases" :start-angle="0"
                                :auto-adjust-text-size="true" hover :total="100.0">
                                <h2>BASES</h2>
                            </vc-donut>

                            <template>
                                <v-data-table v-if="currentFormula.formula_base" :headers="bases_header"
                                    :items="currentFormula.formula_base" :sort-by="['ppc']" :sort-desc="[true]"
                                    class="elevation-1" hide-default-footer show-expand :single-expand=true>

                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length">
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="4">
                                                            <v-text-field v-model="item.cod_base.dureza" label="Dureza"
                                                                prepend-icon="mdi-alpha-d-circle" readonly />
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="4">
                                                            <v-checkbox v-model="item.cod_base.fda" label="FDA" readonly />
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </td>
                                    </template>

                                    <template v-slot:top>
                                        <v-toolbar flat>
                                            <v-toolbar-title>BASES</v-toolbar-title>
                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <v-spacer></v-spacer>
                                            <v-dialog v-model="dialogBase" max-width="500px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                                        Añadir
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="text-h5">{{ formBaseTitle }}</span>
                                                    </v-card-title>

                                                    <v-card-text>
                                                        <v-container>
                                                            <v-form ref="formBase">
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-autocomplete v-model="editedBaseItem.cod_base"
                                                                            :rules="[(v) => !!v || 'Escoja una base']"
                                                                            :items="bases" :item-text="getBaseText"
                                                                            :hint="`${editedBaseItem.cod_base.descripcion}`"
                                                                            item-value="cod_base" label="Codigo"
                                                                            persistent-hint return-object>
                                                                        </v-autocomplete>
                                                                    </v-col>
                                                                </v-row>

                                                                <v-row>
                                                                    <v-col cols=" 12" sm="6" md="6">
                                                                        <v-text-field v-model="editedBaseItem.ppc"
                                                                            label="PPC" type="number">
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-form>

                                                            <div class="mt-3 red--text">{{ errorPPC }}</div>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeBase">
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn color="blue darken-1" text @click="saveBase">
                                                            Guardar
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>

                                            <v-dialog v-model="dialogBaseDelete" max-width="500px">
                                                <v-card>
                                                    <v-card-title class="text-h5">¿Estás seguro de borrar la Base?
                                                    </v-card-title>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeBaseDelete">
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn color="blue darken-1" text @click="deleteBaseItemConfirm">
                                                            Borrar
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-toolbar>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small class="mr-2" @click="editBasesItem(item)">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon small @click="deleteBasesItem(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col>
                        <v-card flat>
                            <vc-donut :size="40" unit="%" :thickness="30" :sections="formula_aditivos" :start-angle="0"
                                :auto-adjust-text-size="true" hover :total="sumAditivos">
                                <h2 color="primary">ADITIVOS</h2>
                            </vc-donut>

                            <template>
                                <v-data-table v-if="currentFormula.formula_aditivo" :headers="aditivos_header"
                                    :items="currentFormula.formula_aditivo" :sort-by="['ppc']" :sort-desc="[true]"
                                    class="elevation-1" hide-default-footer show-expand :single-expand=true>

                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length">
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-checkbox v-model="item.cod_aditivo.aceite" label="Aceite"
                                                            readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.cables" label="Cables"
                                                            readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.desmoldeo" label="Desmoldeo"
                                                            readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.esponja" label="Esponja"
                                                            readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.fda" label="FDA" readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.grasa" label="Grasa"
                                                            readonly />
                                                        <v-checkbox v-model="item.cod_aditivo.green_strength"
                                                            label="Green Strength" readonly />
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </td>
                                    </template>


                                    <template v-slot:top>
                                        <v-toolbar flat>
                                            <v-toolbar-title>ADITIVOS</v-toolbar-title>
                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <v-spacer></v-spacer>
                                            <v-dialog v-model="dialogAditivo" max-width="500px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                                        Añadir
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="text-h5">{{ formAditivoTitle }}</span>
                                                    </v-card-title>

                                                    <v-card-text>
                                                        <v-container>
                                                            <v-form ref="formAditivo">
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-autocomplete
                                                                            v-model="editedAditivoItem.cod_aditivo"
                                                                            :rules="[(v) => !!v || 'Escoja un Aditivo']"
                                                                            :items="aditivos" :item-text="getAditivoText"
                                                                            :hint="`${editedAditivoItem.cod_aditivo.descripcion}`"
                                                                            item-value="cod_aditivo" label="Codigo"
                                                                            persistent-hint return-object>
                                                                        </v-autocomplete>
                                                                    </v-col>
                                                                </v-row>

                                                                <v-row>
                                                                    <v-col cols=" 12" sm="6" md="6">
                                                                        <v-text-field v-model="editedAditivoItem.ppc"
                                                                            label="PPC" type="number">
                                                                        </v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                <div class="mt-3 red--text">{{ errorAditivoPPC }}</div>
                                                            </v-form>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeAditivo">
                                                            Cancelar
                                                        </v-btn>
                                                        <v-btn color="blue darken-1" text @click="saveAditivo">
                                                            Guardar
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>

                                            <v-dialog v-model="dialogAditivoDelete" max-width="500px">
                                                <v-card>
                                                    <v-card-title class="text-h5">¿Estás seguro de borrar el aditivo?
                                                    </v-card-title>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeAditivoDelete">
                                                            Cancelar</v-btn>
                                                        <v-btn color="blue darken-1" text @click="deleteAditivoItemConfirm">
                                                            Borrar
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-toolbar>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small class="mr-2" @click="editAditivosItem(item)">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon small @click="deleteAditivosItem(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small class="mr-2" @click="editAditivosItem(item)">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon small @click="deleteAditivosItem(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </template>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col align="center">
                        <v-container fluid>
                            <v-row align="center">
                                <v-col>
                                    <v-radio-group v-model="currentFormula.platino" row mandatory>
                                        <v-radio :value=true label="Platino"></v-radio>
                                        <v-radio :value=false label="Peroxido"></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.aceite" label="Aceite" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.cables" label="Cables" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.esponja" label="Esponja" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.desmoldeo" label="Desmoldeo" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.fda" label="FDA" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.fuego" label="Fuego" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.grasa" label="Grasa" />
                                </v-col>
                                <v-col>
                                    <v-checkbox v-model="currentFormula.green_strength" label="Green Strength" />
                                </v-col>
                                <v-col></v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <Postcurado :key="sinpostKey" title="Sin Postcurado" icon="mdi-chart-donut"
                            v-if="currentFormula.sinpostcurado" :formula="currentFormula.sinpostcurado" />
                    </v-col>
                    <v-col>
                        <Postcurado :key="conpostKey" title="Con Postcurado" icon="mdi-chart-donut-variant"
                            v-if="currentFormula.postcurado" :formula="currentFormula.postcurado" />
                    </v-col>
                </v-row>

                <v-dialog v-model="dialogCambioCodigo" persistent max-width="600">
                    <v-card>
                        <v-card-title class="text-h5">
                            ¿Desea cambiar el código?
                        </v-card-title>
                        <v-card-text>
                            La fórmula {{ this.$route.params.id }} se va a guardar con un nuevo código:
                            <v-text-field v-model="currentFormula.cod_formula"
                                :rules="[(v) => !!v || 'Código de formula es necesario']" required>
                            </v-text-field>

                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" text @click="dialogCambioCodigo = false">
                                Cancelar
                            </v-btn>

                            <v-btn color="success" class="mr-2" @click="updateFormula(true)">
                                Actualizar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <DialogDelete @deleteFnc="deleteFormula" @closeFnc="showDeleteDialog" title="¿Quieres borrar la fórmula?"
                    :display="this.dialogDeleteShow" />

                <v-row>
                    <v-col align="center">
                        <v-btn v-if="this.editing" color="error" class="mr-2" @click="showDeleteDialog">
                            Borrar
                        </v-btn>

                        <v-btn v-if="this.editing" color="success" class="mr-2" @click="updateFormula(false)">
                            Actualizar
                        </v-btn>

                        <v-btn v-if="!this.editing" color="success" class="mr-2" @click="saveFormula">
                            Guardar
                        </v-btn>

                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import { mapMutations } from "vuex";

import AditivosDataService from "@/services/AditivosDataService";
import AplicacionesDataService from "@/services/AplicacionesDataService";
import BasesDataService from "@/services/BasesDataService";
import ColoresDataService from "@/services/ColoresDataService";
import FormulasDataService from "@/services/FormulasDataService";
import Postcurado from "@/components/Postcurado.vue";
import DialogDelete from "@/components/DialogDelete.vue";

export default {
    name: "Formula",
    props: ["id"],
    data() {
        return {
            sinpostKey: 0,
            conpostKey: 0,
            codigoFormula: "",
            newFormula: null,
            editing: false,
            formulaBase: [],
            dialogBase: false,
            dialogBaseDelete: false,
            prevPPC: 0,
            editedBaseIndex: -1,
            editedBaseItem: {
                "cod_base": {
                    "cod_base": "",
                    "descripcion": "",
                    "fda": false,
                    "dureza": 0,
                },
                "ppc": 0
            },
            defaultBaseItem: {
                "cod_base": {
                    "cod_base": "",
                    "descripcion": "",
                    "fda": false,
                    "dureza": 0,
                },
                "ppc": 0
            },
            dialogAditivo: false,
            dialogAditivoDelete: false,
            editedAditivoIndex: -1,
            editedAditivoItem: {
                "cod_aditivo": {
                    "cod_aditivo": "",
                    "descripcion": "",
                    "fda": false,
                    "dureza": 0,
                },
                "ppc": 0
            },
            defaultAditivoItem: {
                "cod_aditivo": {
                    "cod_aditivo": "",
                    "descripcion": "",
                    "fda": false,
                    "dureza": 0,
                },
                "ppc": 0
            },
            aplicaciones: [],
            currentFormula: {
                "cod_formula": "",
                "descripcion": "",
                "cliente": "",
                "especificacion": "",
                "proceso": null,
                "platino": false,
                "esponja": false,
                "temp_servicio": null,
                "fda": false,
                "id_color": null,
                "densidad": null,
                "postcurado": {
                    valor: '-',
                    alargamiento: null,
                    c_set: null,
                    carga_rot_mpa: null,
                    desgarro: null,
                    dureza: null,
                },
                "sinpostcurado": {
                    valor: '-',
                    alargamiento: null,
                    c_set: null,
                    carga_rot_mpa: null,
                    desgarro: null,
                    dureza: null,
                },
                "aceite": false,
                "grasa": false,
                "fuego": false,
                "green_strength": false,
                "desmoldeo": false,
                "cables": false,
                "id_busqueda": null,
                "fiable": true,
                "formula_aditivo": [],
                "formula_aplicacion": [],
                "formula_base": [],
            },
            precio_total: 0.0,
            errorPPC: "",
            errorAditivoPPC: "",
            formula_bases: [],
            bases_header: [
                { text: "Codigo", value: "cod_base.cod_base", align: "start" },
                { text: "Descripcion", value: "cod_base.descripcion" },
                { text: "ppc", value: "ppc" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            formula_aditivos: [],
            sumAditivos: 100,
            aditivos_header: [
                { text: "Codigo", value: "cod_aditivo.cod_aditivo", align: "start" },
                { text: "Descripcion", value: "cod_aditivo.descripcion" },
                { text: "ppc", value: "ppc" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            descriptionLimit: 50,
            model_aplicacion: [],
            colores: [],
            isLoading: false,
            proceso: [
                { name: "Autoclave", abbr: "AC", value: "autoclave" },
                { name: "Calandra", abbr: "C", value: "calandra" },
                { name: "Extrusion", abbr: "E", value: "extrusion" },
                { name: "Moldeo", abbr: "M", value: "moldeo" },
            ],
            bases: [],
            aditivos: [],
            dialogConvertirFormula: false,
            dialogClonar: false,
            cod_formula_clonado: "",
            dialogCambioCodigo: false,
            dialogDeleteShow: false,
        };
    },
    computed: {
        formBaseTitle() {
            if (this.editedBaseIndex === -1) {
                return "Nuevo";
            }
            else {
                return "Editar";
            }
        },
        formAditivoTitle() {
            if (this.editedAditivoIndex === -1) {
                return "Nuevo";
            }
            else {
                return "Editar";
            }
        },
    },
    watch: {
        dialogBase(val) {
            val || this.closeBase();
        },
        dialogBaseDelete(val) {
            val || this.closeBaseDelete();
        },
        dialogAditivo(val) {
            val || this.closeAditivo();
        },
        dialogAditivoDelete(val) {
            val || this.closeAditivoDelete();
        },
        dialogConvertirFormula(val) {
            val || this.closeConvertirFormula();
        },
        "$route.params.id"(newId, oldId) {
            this.$refs.formulario.reset();
            this.formula_bases = [];
            this.formula_aditivos = [];
            this.model_aplicacion = [];
            this.cod_formula_clonado = "";

            if (newId != null) {
                this.getFormula(newId);
                this.editing = true;
            } else {
                this.editing = false;
                this.currentFormula = {
                    "cod_formula": "",
                    "descripcion": "",
                    "cliente": "",
                    "especificacion": "",
                    "proceso": null,
                    "platino": false,
                    "esponja": false,
                    "temp_servicio": null,
                    "fda": false,
                    "id_color": null,
                    "densidad": null,
                    "postcurado": {
                        valor: "-",
                        alargamiento: null,
                        c_set: null,
                        carga_rot_mpa: null,
                        desgarro: null,
                        dureza: null,
                    },
                    "sinpostcurado": {
                        valor: "-",
                        alargamiento: null,
                        c_set: null,
                        carga_rot_mpa: null,
                        desgarro: null,
                        dureza: null,
                    },
                    "aceite": false,
                    "grasa": false,
                    "fuego": false,
                    "green_strength": false,
                    "desmoldeo": false,
                    "cables": false,
                    "id_busqueda": null,
                    "fiable": true,
                    "formula_aditivo": [],
                    "formula_aplicacion": [],
                    "formula_base": [],
                };
            }
            this.$refs.formulario.resetValidation();
        },
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        editBasesItem(item) {
            this.editedBaseIndex = this.currentFormula.formula_base.indexOf(item);
            this.editedBaseItem = Object.assign({}, item);
            this.prevPPC = this.editedBaseItem.ppc;
            this.dialogBase = true;

        },
        deleteBasesItem(item) {
            this.editedBaseIndex = this.currentFormula.formula_base.indexOf(item);
            this.editedBaseItem = Object.assign({}, item);
            this.dialogBaseDelete = true;
        },
        deleteBaseItemConfirm() {
            this.currentFormula.formula_base.splice(this.editedBaseIndex, 1);
            this.formula_bases.splice(this.editedBaseIndex, 1);
            this.closeBaseDelete();
        },
        closeBase() {
            this.dialogBase = false;
            this.$nextTick(() => {
                this.editedBaseItem = Object.assign({}, this.defaultBaseItem);
                this.editedBaseIndex = -1;
            });
        },
        closeBaseDelete() {
            this.dialogBaseDelete = false;
            this.$nextTick(() => {
                this.editedBaseItem = Object.assign({}, this.defaultBaseItem);
                this.editedBaseIndex = -1;
            });
        },
        saveBase() {
            if (this.$refs.formBase.validate()) {
                let sumPPC = this.currentFormula.formula_base.reduce((a, b) => parseFloat(a) + (parseFloat(b["ppc"]) || 0), 0);
                if (this.editedBaseIndex < 0) {
                    this.editedBaseIndex = this.currentFormula.formula_base.length;
                }
                if (this.editedBaseIndex >= this.currentFormula.formula_base.length) {
                    this.prevPPC = 0;
                }
                sumPPC = sumPPC - parseFloat(this.prevPPC) + parseFloat(this.editedBaseItem.ppc);
                if (sumPPC > 100) {
                    this.errorPPC = "Las BASES suman más de 100";
                    return;
                }
                else {
                    if (this.editedBaseItem.ppc <= 0) {
                        this.errorPPC = "PPC debe ser mayor de 0";
                        return;
                    }
                    else {
                        this.errorPPC = "";
                    }
                }
                if (this.editedBaseIndex < this.currentFormula.formula_base.length) {
                    Object.assign(this.currentFormula.formula_base[this.editedBaseIndex], this.editedBaseItem);
                    Object.assign(this.formula_bases[this.editedBaseIndex], {
                        label: this.editedBaseItem.cod_base.cod_base + " (" + this.editedBaseItem.ppc + " ppc)",
                        value: parseFloat(this.editedBaseItem.ppc),
                    });
                }
                else {
                    this.currentFormula.formula_base.push(this.editedBaseItem);
                    this.formula_bases.push({
                        label: this.editedBaseItem.cod_base.cod_base + " (" + this.editedBaseItem.ppc + " ppc)",
                        value: parseFloat(this.editedBaseItem.ppc),
                    });
                }
                this.closeBase();
            } else {
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
        editAditivosItem(item) {
            this.editedAditivoIndex = this.currentFormula.formula_aditivo.indexOf(item);
            this.editedAditivoItem = Object.assign({}, item);
            this.prevPPC = this.editedAditivoItem.ppc;
            this.dialogAditivo = true;
        },
        deleteAditivosItem(item) {
            this.editedAditivoIndex = this.currentFormula.formula_aditivo.indexOf(item);
            this.editedAditivoItem = Object.assign({}, item);
            this.dialogAditivoDelete = true;
        },
        deleteAditivoItemConfirm() {
            this.currentFormula.formula_aditivo.splice(this.editedAditivoIndex, 1);
            this.formula_aditivos.splice(this.editedAditivoIndex, 1);
            this.closeAditivoDelete();
        },
        closeAditivo() {
            this.dialogAditivo = false;
            this.$nextTick(() => {
                this.editedAditivoItem = Object.assign({}, this.defaultAditivoItem);
                this.editedAditivoIndex = -1;
            });
        },
        closeAditivoDelete() {
            this.dialogAditivoDelete = false;
            this.$nextTick(() => {
                this.editedAditivoItem = Object.assign({}, this.defaultAditivoItem);
                this.editedAditivoIndex = -1;
            });
        },
        saveAditivo() {
            if (this.$refs.formAditivo.validate()) {
                if (this.editedAditivoItem.cod_aditivo.cod_aditivo) {
                    this.editedAditivoItem.ppc = parseFloat(this.editedAditivoItem.ppc);
                    if (this.editedAditivoItem.ppc <= 0) {
                        this.errorAditivoPPC = "PPC debe ser mayor de 0";
                        return;
                    }
                    else {
                        this.errorAditivoPPC = "";
                    }

                    if (this.editedAditivoIndex < 0) {
                        this.editedAditivoIndex = this.currentFormula.formula_aditivo.length;
                    }
                    if (this.editedAditivoIndex < this.currentFormula.formula_aditivo.length) {
                        Object.assign(this.currentFormula.formula_aditivo[this.editedAditivoIndex], this.editedAditivoItem);

                        let sumaAditivosPPC = 0;
                        for (const element of this.formula_aditivos) {
                            sumaAditivosPPC += element.ppc;
                        }
                        sumaAditivosPPC += parseFloat(this.editedAditivoItem.ppc);
                        this.sumAditivos = Math.max(100, Math.ceil(sumaAditivosPPC));

                        Object.assign(this.formula_aditivos[this.editedAditivoIndex], {
                            label: this.editedAditivoItem.cod_aditivo.cod_aditivo + " (" + this.editedAditivoItem.ppc + " ppc)",
                            value: parseFloat(this.editedAditivoItem.ppc),
                        });
                    }
                    else {
                        this.currentFormula.formula_aditivo.push(this.editedAditivoItem);

                        let sumaAditivosPPC = 0;
                        for (const element of this.currentFormula.formula_aditivo) {
                            sumaAditivosPPC += element.ppc;
                        }
                        this.sumAditivos = Math.max(100, Math.ceil(sumaAditivosPPC));

                        this.formula_aditivos.push({
                            label: this.editedAditivoItem.cod_aditivo.cod_aditivo + " (" + this.editedAditivoItem.ppc + " ppc)",
                            value: parseFloat(this.editedAditivoItem.ppc),
                        });
                    }
                    this.closeAditivo();
                }
            } else {
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
        removeColor(item) {
            this.currentFormula.id_color = null;
        },
        removeAplicacion(item) {
            for (let i = 0; i < this.model_aplicacion.length; i++) {
                const element = this.model_aplicacion[i];
                if (element.id_aplicacion === item.id_aplicacion) {
                    this.model_aplicacion.splice(i, 1);
                }
            }
        },
        customFilter(item, queryText, itemText) {
            const textOne = item.name.toLowerCase();
            const textTwo = item.abbr.toLowerCase();
            const searchText = queryText.toLowerCase();
            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1;
        },
        getColorName(item) {
            let str_color = item.nombre;
            if (item.ral != "") {
                str_color += " (" + item.ral + ")";
            }
            if (item.referencia != "") {
                str_color += " [" + item.referencia + "]";
            }
            return str_color;
        },
        setPostcurado() {
            let postcurado_dict = {
                valor: this.currentFormula.postcurado_valor,
                alargamiento: this.currentFormula.postcurado_alargamiento,
                c_set: this.currentFormula.postcurado_c_set,
                carga_rot_mpa: this.currentFormula.postcurado_carga_rot_mpa,
                desgarro: this.currentFormula.postcurado_desgarro,
                dureza: this.currentFormula.postcurado_dureza,
            }
            this.currentFormula['postcurado'] = postcurado_dict;
            let sinpostcurado_dict = {
                valor: this.currentFormula.sinpostcurado_valor,
                alargamiento: this.currentFormula.sinpostcurado_alargamiento,
                c_set: this.currentFormula.sinpostcurado_c_set,
                carga_rot_mpa: this.currentFormula.sinpostcurado_carga_rot_mpa,
                desgarro: this.currentFormula.sinpostcurado_desgarro,
                dureza: this.currentFormula.sinpostcurado_dureza,
            }
            this.currentFormula['sinpostcurado'] = sinpostcurado_dict;
            this.sinpostKey += 1;
            this.conpostKey += 1;
        },
        getNewFormula() {
            delete this.newFormula;
            this.newFormula = Object.assign({}, this.currentFormula);
            if (this.cod_formula_clonado != "") {
                this.newFormula.cod_formula = this.cod_formula_clonado;
                // console.log("HEMOS CAMBIADO EL CODIGO DE LA FORMULA"); console.log(this.cod_formula_clonado);
            }
            delete this.newFormula.formula_aplicacion;
            delete this.newFormula.postcurado;
            delete this.newFormula.sinpostcurado;

            this.newFormula.sinpostcurado_valor = this.currentFormula.sinpostcurado.valor;
            this.newFormula.sinpostcurado_alargamiento = this.currentFormula.sinpostcurado.alargamiento;
            this.newFormula.sinpostcurado_c_set = this.currentFormula.sinpostcurado.c_set;
            this.newFormula.sinpostcurado_carga_rot_mpa = this.currentFormula.sinpostcurado.carga_rot_mpa;
            this.newFormula.sinpostcurado_desgarro = this.currentFormula.sinpostcurado.desgarro;
            this.newFormula.sinpostcurado_dureza = this.currentFormula.sinpostcurado.dureza;

            this.newFormula.postcurado_valor = this.currentFormula.postcurado.valor;
            this.newFormula.postcurado_alargamiento = this.currentFormula.postcurado.alargamiento;
            this.newFormula.postcurado_c_set = this.currentFormula.postcurado.c_set;
            this.newFormula.postcurado_carga_rot_mpa = this.currentFormula.postcurado.carga_rot_mpa;
            this.newFormula.postcurado_desgarro = this.currentFormula.postcurado.desgarro;
            this.newFormula.postcurado_dureza = this.currentFormula.postcurado.dureza;

            this.newFormula.formula_aplicacion = [];
            for (let i = 0; i < this.model_aplicacion.length; i++) {
                let element = { "id": i + 1, "id_aplicacion": this.model_aplicacion[i] };
                this.newFormula.formula_aplicacion.push(element);
            }

        },
        getFormula(id) {
            FormulasDataService.get(id)
                .then((response) => {
                    this.currentFormula = response.data;
                    let ppc_total = 0.0
                    var dict = new Object();

                    for (const base of this.currentFormula.formula_base) {
                        for (const proveedor of base.cod_base.proveedor_base) {
                            ppc_total += base.ppc;
                            dict[base.cod_base.cod_base] = {};
                            dict[base.cod_base.cod_base].ppc = base.ppc;
                            dict[base.cod_base.cod_base].precio = proveedor.precio;
                        }
                    }

                    for (const aditivo of this.currentFormula.formula_aditivo) {
                        for (const proveedor of aditivo.cod_aditivo.proveedor_aditivo) {
                            ppc_total += aditivo.ppc;
                            dict[aditivo.cod_aditivo.cod_aditivo] = {};
                            dict[aditivo.cod_aditivo.cod_aditivo].ppc = aditivo.ppc;
                            dict[aditivo.cod_aditivo.cod_aditivo].precio = proveedor.precio;
                        }
                    }

                    let total = 0.0;
                    for (var key in dict) {
                        var value = dict[key];
                        total += (value.ppc / ppc_total) * value.precio
                    }
                    this.precio_total = total.toFixed(2);

                    for (const element of this.currentFormula.formula_base) {
                        delete element.id;
                    }
                    for (const element of this.currentFormula.formula_aditivo) {
                        delete element.id;
                    }
                    this.setPostcurado();

                    let list_formula_bases = response.data.formula_base;
                    for (const element of list_formula_bases) {
                        this.formula_bases.push({ label: element.cod_base.cod_base + " (" + element.ppc + " ppc)", value: element.ppc, });
                    }
                    let list_formula_aditivos = response.data.formula_aditivo;
                    if (list_formula_aditivos.length > 0) {
                        let sumaAditivosPPC = 0;
                        for (const element of list_formula_aditivos) {
                            this.formula_aditivos.push({ label: element.cod_aditivo.cod_aditivo + " (" + element.ppc + " ppc)", value: element.ppc, });
                            sumaAditivosPPC += element.ppc;
                        }
                        this.sumAditivos = Math.max(100, Math.ceil(sumaAditivosPPC));
                    }
                    if (this.currentFormula.formula_aplicacion.length > 0) {
                        for (const element of this.currentFormula.formula_aplicacion) {
                            this.model_aplicacion.push(element.id_aplicacion);
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        saveFormula() {
            if (this.$refs.formulario.validate()) {
                this.getNewFormula();

                FormulasDataService.create(this.newFormula)
                    .then((response) => {
                        this.setSnack({ message: "Creado correctamente", color: "success" });
                        if (this.newFormula.id_busqueda != null) {
                            this.$router.push({ name: "SugerenciaId", params: { id: this.newFormula.id_busqueda.id_busqueda } });
                        } else {
                            this.$router.push({ name: "FormulasList" });
                        }
                    })
                    .catch((e) => {
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                        }
                        else {
                            this.setSnack({ message: e.message, color: "error" });
                        }
                    });
            } else {
                this.setSnack({ message: "Revise los campos en rojo del formulario", color: "error" });
            }
        },
        updateFormula(confirmado) {
            if (this.$refs.formulario.validate()) {
                // console.log("getNewFormula");
                this.getNewFormula();

                if (this.$route.params.id != this.currentFormula.cod_formula && !confirmado) {
                    // console.log("VAS A CAMBIAR EL CÓDIGO DE ESTA FORMULA");
                    this.showConfirmaCodigoDialog();
                    return
                }

                FormulasDataService.update(this.$route.params.id, this.newFormula)
                    .then((response) => {
                        this.setSnack({ message: "Actualizado correctamente", color: "success" });
                        if (this.newFormula.id_busqueda != null) {
                            this.$router.push({ name: "SugerenciaId", params: { id: this.newFormula.id_busqueda.id_busqueda } });
                        } else {
                            this.$router.push({ name: "FormulasList" });
                        }
                    })
                    .catch((e) => {
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                        }
                        else {
                            this.setSnack({ message: e.message, color: "error" });
                        }
                    });
            } else {
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
        deleteFormula() {
            let busqueda_id = this.currentFormula.id_busqueda;
            FormulasDataService.delete(this.$route.params.id)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.dialogDeleteShow = false;

                    if (busqueda_id != null) {
                        this.$router.push({ name: "SugerenciaId", params: { id: busqueda_id } });
                    } else {
                        this.$router.push({ name: "FormulasList" });
                    }
                })
                .catch((e) => {
                    this.dialogDeleteShow = false;
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        getBaseText(item) {
            return item.cod_base + " (" + item.descripcion + ")"
        },
        getAditivoText(item) {
            return item.cod_aditivo + " (" + item.descripcion + ")"
        },
        convertirFormula() {
            if (this.$route.params.id === this.currentFormula.cod_formula) {
                this.currentFormula.cod_formula = "";
                this.closeConvertirFormula();
                this.setSnack({ message: "Asigne un nuevo código a la formula", color: "error" });
                return;
            }
            if (this.$refs.formulario.validate()) {
                this.getNewFormula();
                this.newFormula.fiable = true;
                this.newFormula.id_busqueda = null;
                FormulasDataService.create(this.newFormula)
                    .then((response) => {
                        this.setSnack({ message: "Creado correctamente", color: "success" });
                        if (this.newFormula.id_busqueda != null) {
                            this.$router.push({ name: "SugerenciaId", params: { id: this.newFormula.id_busqueda.id_busqueda } });
                        } else {
                            setTimeout(() => this.$router.push({ name: "FormulaId", params: { id: this.newFormula.cod_formula } }), 1000);
                        }
                    })
                    .catch((e) => {
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                            this.closeConvertirFormula();
                        }
                        else {
                            this.setSnack({ message: e.message, color: "error" });
                            this.closeConvertirFormula();
                        }
                    });
            } else {
                this.closeConvertirFormula();
                this.setSnack({ message: "Revise los campos en rojo del formulario", color: "error" });
            }
        },
        closeConvertirFormula() {
            this.dialogConvertirFormula = false;
        },
        clonarFormula() {
            if (this.$route.params.id === this.cod_formula_clonado || this.cod_formula_clonado === "") {
                this.cod_formula_clonado = "";
                this.setSnack({ message: "Asigne un código DIFERENTE a la formula", color: "error" });
                return;
            }

            if (this.$refs.formulario.validate()) {
                this.getNewFormula();
                this.newFormula.fiable = true;
                this.newFormula.id_busqueda = null;
                FormulasDataService.create(this.newFormula)
                    .then((response) => {
                        this.cod_formula_clonado = "";
                        this.dialogClonar = false;
                        this.setSnack({ message: "Clonado correctamente", color: "success" });
                        this.$router.push({ name: "FormulaId", params: { id: this.newFormula.cod_formula } });
                    })
                    .catch((e) => {
                        if (e.response.data.detail) {
                            this.setSnack({ message: e.response.data.detail, color: "error" });
                        }
                        else {
                            this.setSnack({ message: e.message, color: "error" });
                        }
                    });
            } else {
                this.setSnack({ message: "Revise los campos en rojo del formulario", color: "error" });
            }
        },
        showClonarDialog() {
            this.dialogClonar = !this.dialogClonar
        },
        showConfirmaCodigoDialog() {
            this.dialogCambioCodigo = !this.dialogCambioCodigo
        },
        showDeleteDialog() {
            this.dialogDeleteShow = !this.dialogDeleteShow
            // console.log("showDeleteDialog"); console.log(this.dialogDeleteShow);
        }
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getFormula(this.$route.params.id);
            this.editing = true;
        }
        // Lazily load input items
        AplicacionesDataService.getSimple()
            .then((response) => {
                this.aplicaciones = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        ColoresDataService.getSimple()
            .then((response) => {
                this.colores = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        BasesDataService.getSimple()
            .then((response) => {
                this.bases = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
        AditivosDataService.getSimple()
            .then((response) => {
                this.aditivos = response.data;
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false));
    },
    components: { Postcurado, DialogDelete }
};
</script>
